
if (!window.drawers && false) {
  window.drawers = true;
  const cartOpenButton = document.getElementById("open-cart-button");
  const cartCloseButton = document.getElementById("cart-close-button");
  const cartBackButton = document.querySelector(".cart-button");
  const cartDrawer = document.getElementById("cart-drawer");
  //cartOpenButton.addEventListener("click", openCartDrawer);
  //cartCloseButton.addEventListener("click", closeCartDrawer);
  //cartBackButton.addEventListener("click", closeCartDrawer);

  function openCartDrawer(e) {
    cartDrawer.classList.add("open");
  }
  function closeCartDrawer(e) {
    cartDrawer.classList.remove("open");
  }

  const menuOpenButton = document.getElementById("open-menu-button");
  const menuCloseButton = document.getElementById("menu-close-button");
  const menuDrawer = document.getElementById("menu-drawer");
  menuOpenButton.addEventListener("click", openMenuDrawer);
  menuCloseButton.addEventListener("click", closeMenuDrawer);

  function openMenuDrawer(e) {
    menuDrawer.classList.add("open");
  }
  function closeMenuDrawer(e) {
    menuDrawer.classList.remove("open");
  }

  const backDrawer = document.querySelector(".menu-drawer-back");
  backDrawer.addEventListener("click", closeCurrentDrawer);

  function closeCurrentDrawer(e) {
    const openDrawer = document.querySelector("aside.open");
    openDrawer.classList.remove("open");
  }
}

if (!window.faqSec) {
  window.faqSec = true;
  document.querySelectorAll(".faq__question").forEach((element) =>
    element.addEventListener("click", (event) => {
      const detailsElement = event.target.parentElement;
      const contentElement = event.target.nextElementSibling;

      if (contentElement.classList.contains("animation")) {
        contentElement.classList.remove("animation", "collapsing");
        void element.offsetWidth;
        return;
      }

      const onAnimationEnd = (cb) =>
        contentElement.addEventListener("animationend", cb, {
          once: true,
        });

      requestAnimationFrame(() =>
        contentElement.classList.add("animation")
      );
      onAnimationEnd(() => contentElement.classList.remove("animation"));

      const isDetailsOpen = detailsElement.getAttribute("open") !== null;
      if (isDetailsOpen) {
        event.preventDefault();
        contentElement.classList.add("collapsing");
        onAnimationEnd(() => {
          detailsElement.removeAttribute("open");
          contentElement.classList.remove("collapsing");
        });
      }
    })
  );

  const faqButtons = document.querySelectorAll(".faq__button");
  if (faqButtons && faqButtons.length > 0) {
    faqButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const id = btn.dataset.controll;
        document.getElementById(`faq-${id}`).classList.toggle("open");
      });
    });
  }
}

if (!window.study) {
  window.study = true;
  const studies = document.getElementById("studies");
  const studiesButton = document.querySelector(".study__button");

  studiesButton.addEventListener("click", () => {
    studies.classList.toggle("open");
  })
}
if (!window.study && false) {
  window.study = true;
  
  const studies = document.getElementById("studies");
  const studiesButton = document.querySelector(".study__button");

  studiesButton.addEventListener("click", () => {
    studies.classList.toggle("open");

    Number.prototype.format = function(n) {
      var r = new RegExp('\\d(?=(\\d{3})+' + (n > 0 ? '\\.' : '$') + ')', 'g');
      return this.toFixed(Math.max(0, Math.floor(n))).replace(r, '$&,');
    };

    $('.count').each(function () {
        $(this).prop('counter', 0).animate({
            counter: $(this).text()
        }, {
            duration: 1500,
            step: function (step) {
                $(this).text('' + step.format());
            }
        });
    });
    
    setInterval(() => {
      if (studies.classList.contains("open")) {
        Number.prototype.format = function(n) {
        var r = new RegExp('\\d(?=(\\d{3})+' + (n > 0 ? '\\.' : '$') + ')', 'g');
        return this.toFixed(Math.max(0, Math.floor(n))).replace(r, '$&,');
      };

      $('.count').each(function () {
          $(this).prop('counter', 0).animate({
              counter: $(this).text()
          }, {
              duration: 1500,
              step: function (step) {
                  $(this).text('' + step.format());
              }
          });
      });
      }
    }, 15000)
  })
}

if (!window.productSlider) {
  window.productSlider = true;
  const carousselProduct = document.querySelector(".carousel-product");
  const carousselProductInner = carousselProduct.querySelector(
    ".carousel-product__inner"
  );
  const controlButtons = document.querySelectorAll(
    ".carousel-product__control"
  );
  const bulletsProduct = document.querySelector(
    ".carousel-product__bullets"
  );
  let currentProductCarouselItem = 0;

  controlButtons.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      if (e.target.classList.contains("carousel-product__control")) {
        slideProductWithButton(e);
      }
    });
  });
  bulletsProduct.addEventListener("click", (e) => {
    const bullet = e.target;
    if (bullet.classList.contains("carousel-product__bullet")) {
      const index = +bullet.id.replace("bullet-", "");

      currentProductCarouselItem = index;
      moveCarouselProduct();
      updateCarouselProduct();
    }
  });

  function slideProductWithButton(e) {
    const carousselWidth = carousselProduct.offsetWidth;
    const type = e.target.dataset.type;
    if (type === "prev") {
      currentProductCarouselItem -= 1;
      moveCarouselProduct();
    } else if (type === "next") {
      currentProductCarouselItem += 1;
      moveCarouselProduct();
    }
    updateCarouselProduct();
  }

  function moveCarouselProduct() {
    dynamicArrowDisplay();
    const carousselWidth = carousselProduct.offsetWidth;
    carousselProductInner.style.transform = `translateX(-${
      carousselWidth * currentProductCarouselItem
    }px)`;
  }

  function dynamicArrowDisplay() {
    if (currentProductCarouselItem === 0) {
      const prevButton = document.querySelector(
        ".carousel-product__control.prev"
      );
      prevButton.classList.add("inactive");
    } else if (
      currentProductCarouselItem >
      document.querySelectorAll(".carousel-product__item").length - 2
    ) {
      const nextButton = document.querySelector(
        ".carousel-product__control.next"
      );
      nextButton.classList.add("inactive");
    } else {
      const inactiveButton = document.querySelector(
        ".carousel-product__control.inactive"
      );
      if (inactiveButton) inactiveButton.classList.remove("inactive");
    }
  }

  function updateCarouselProduct() {
    const prevItem = document.querySelector(
      ".carousel-product__bullet.active"
    );
    const currentItem = document.querySelector(
      `.carousel-product__bullet.control-${currentProductCarouselItem}`
    );
    prevItem.classList.remove("active");
    currentItem.classList.add("active");
  }
}

if (!window.cardToggles) {
  window.cardToggles = true;
  const cardToggle3 = document.querySelectorAll("input[name=subs-3]");
  const cardAddCart3 = document.querySelector(".buy-btn.subs-3");
  const savingsCart3 = document.querySelector(".prod-savings.subs-3");
  const moneyCart3 = document.querySelector(".money.subs-3");
  const totalCart3 = document.querySelector(".total.subs-3");
  if (cardToggle3 && cardToggle3.length > 0) {
    cardToggle3.forEach(ip => {
      ip.addEventListener("change", e => {
        if (ip.id === "one-time-3") {
          cardAddCart3.innerText = "ADD TO CART";
          savingsCart3.innerText = "$61.44";
          moneyCart3.innerText = "$30.72";
          totalCart3.innerText = "TOTAL: $184.32";
        } else if (ip.id === "subs-3") {
          cardAddCart3.innerText = "SUBSCRIBE NOW";
          savingsCart3.innerText = "$89.76";
          moneyCart3.innerText = "$26.00";
          totalCart3.innerText = "TOTAL: $156.00";
        }
      })
    })
  }

  const cardToggle = document.querySelectorAll("input[name=subs-1]");
  const cardAddCart = document.querySelector(".buy-btn.subs-1");
  const savingsCart1 = document.querySelector(".prod-savings.subs-1");
  const moneyCart1 = document.querySelector(".money.subs-1");
  const totalCart1 = document.querySelector(".total.subs-1");
  if (cardToggle && cardToggle.length > 0) {
    cardToggle.forEach(ip => {
      ip.addEventListener("change", e => {
        if (ip.id === "one-time-1") {
          cardAddCart.innerText = "ADD TO CART";
          savingsCart1.innerText = "$22.92";
          moneyCart1.innerText = "$33.32";
          totalCart1.innerText = "TOTAL: $99.96";
        } else if (ip.id === "subs-1") {
          cardAddCart.innerText = "SUBSCRIBE NOW";
          savingsCart1.innerText = "$41.88";
          moneyCart1.innerText = "$27.00";
          totalCart1.innerText = "TOTAL: $84.96";
        }
      })
    })
  }
}

if (!window.prodToggle) {
  window.prodToggle = true;

  const mainButtons = document.querySelectorAll(".main-option");
  const buyButton = document.querySelector(".buy-button");
  const subsMessage = document.querySelector(".subs-message");
  const salePriceEl = document.querySelector(".product-info__price--sale");
  const regularPriceEl = document.querySelector(".product-info__price--regular");
  
  mainButtons.forEach(btn => {
    btn.addEventListener("change", () => {
      if (btn.id === "loop-one-time-purchase-8024184160483") {
        buyButton.innerText = "ADD TO CART";
        subsMessage.classList.remove("active");
        salePriceEl.innerText = "$99.96";
        regularPriceEl.innerText = "$169.92"
      } else {
        buyButton.innerText = "SUBSCRIBE NOW";
        subsMessage.classList.add("active");
        salePriceEl.innerText = "$84.96";
        regularPriceEl.innerText = "$169.92"
      }
    });
  })
}

if (!window.cartClose && false) {
  window.cartClose = true;
  
  document.querySelector("#cart-drawer").addEventListener("click", (e) => {
    if (e.target.tagName === "BUTTON" && e.target.classList.contains("cart-button")) {
      document.querySelector("#cart-drawer").classList.remove("open");
    }
  })
}

if (!window.labelToggle) {
  window.labelToggle = true;
  
  const labelButtons = document.querySelectorAll(".label-button");
  labelButtons.forEach(btn => {
    btn.addEventListener("click", () => {
      const id = btn.dataset.controll;
      document.getElementById(`label-${id}`).classList.toggle("active");
    });
  });
  
  const closeLabelButtons = document.querySelectorAll(".label-close");
  closeLabelButtons.forEach(btn => {
    btn.addEventListener("click", () => {
      const id = btn.dataset.controll;
      document.getElementById(`label-${id}`).classList.remove("active");
    });
  });
  
  const labelBacks = document.querySelectorAll(".label-desktop-back"); 
  labelBacks.forEach(back => {
    back.addEventListener("click", (e) => {
      if (e.target == back) {
        back.firstElementChild.classList.remove("active");
      }
    }) 
  })
}

if (!window.prodBulletsS) {
  window.prodBulletsS = true;
  
  const prodBullets = document.querySelectorAll(".product-bullets__controll");
  const bulletsCont = document.querySelector(".carousel-product__bullets");
  let bulletsCount = 0;
  
  prodBullets.forEach(btn => {
    btn.addEventListener("click", () => {
      if (btn.classList.contains("prev")) {
        bulletsCount -= 1;
      } else if (btn.classList.contains("next")) {
        bulletsCount += 1;
      }
  
      moveBulletCont();
    });
  });
  
  function moveBulletCont() {
    if (bulletsCount === 0) {
      document.querySelector(".product-bullets__controll.prev").classList.add("inactive");
    } else if (bulletsCount === 2) {
      document.querySelector(".product-bullets__controll.next").classList.add("inactive");
    } else {
      document.querySelector(".product-bullets__controll.inactive").classList.remove("inactive");
    }
  
    bulletsCont.style.transform = `translateY(-${bulletsCount * 100}%)`
  }
}

if (!window.cartLogic && false) {
  window.cartLogic = true;
  
  const addCartBoxButton = document.getElementById("quick-add-3-months");
  addCartBoxButton.addEventListener("click", (e) => {
    addToCart(e, 4);
  })
  
  function addToCart(e, quantityForm) {
    const productForm = document.querySelector("form.product-form");
  
    //Animation
    // const button = productForm.querySelector(".product-form__submit[type=submit]")
    // button.classList.toggle("ldng")
  
    const config = {
      method: "POST",
      headers: {
        Accept: "application/javascript",
        "X-Requested-With": "XMLHttpRequest",
      },
    };
  
    // const sectionsToBundle = [document.getElementById("CartDrawer").getAttribute("data-section-id")]
  
    const formData = new FormData(productForm);
    formData.append("sections_url", window.location.pathname);
    formData.append("id", "46118750912739");
    formData.append("quantity", 4);
  
    config.body = formData;
    
  
    fetch(`/cart/add`, config)
      .then((response) => response.json())
      .then(async (parsedState) => {
        if (parsedState.status) {
          // handleErrorMessage(parsedState.description)
        }
  
        const cartJson = await (
          await fetch(`/cart`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          })
        ).json();
        
  
        //window.totalSavings = 0;
        //const newCartJson = await getProdAllData(cartJson);
        const addedToCartMessage = document.getElementById("added-to-cart-message");
        addedToCartMessage.classList.add("active");

        //updateCart(newCartJson);
        //updateCartCount(cartJson.item_count);
  
        // button.classList.toggle("ldng")
        //const cartDrawer = document.getElementById("cart-drawer");
        //cartDrawer.classList.add("open");
      });
    }
  
    /*function updateCart(cartJson, plan) {
      const cartSection = document.querySelector(
        "#cart-drawer .drawer-body section:first-child"
      );
      if (cartJson.items.length > 0) {
        let fragment = "";
        for (const i in cartJson.items) {
          fragment += createCartItem(cartJson.items[i], i, plan);
        }
        cartSection.outerHTML = createCart(fragment, cartJson);
      } else {
        cartSection.outerHTML = emptyCart;
      }
    }
  
    function createCartItem(item, index) {
      const productCard = `<li class="explore-product">
      <img
        class="explore-product__image"
        src="${item.featured_image.url}&width=100"
        alt="${item.title}"
      />
      <div class="explore-product__desc">
        <p class="explore-product__title">
          ${item.title}
        </p>
        <div>
          <p class="explore-product__content">${
            item.selling_plan_allocation
              ? item.selling_plan_allocation.selling_plan.name
              : `One Time Purchase`
          }</p>
        </div>
    
        <div class="explore-product__ext">
          <div class="quant-selector">
            <button
              type="button"
              class="quant-selector__button"
              data-type="minus"
            >
              -
            </button>
            <input
              type="number"
              min="0"
              class="quant-selector__button"
              id="prod-quantity"
              value="${item.quantity}"
              data-index="${+index + 1}"
            />
            <button
              type="button"
              class="quant-selector__button"
              data-type="plus"
            >
              +
            </button>
          </div>
    
          <div class="explore-product__price">
            <p class="explore-product__price--regular">$${
              parseFloat(item.compare_at_price * item.quantity).toFixed(2)
            }</p>
            <p class="explore-product__price--sale">$${
              parseFloat(item.line_price / 100).toFixed(2)
            }</p>
          </div>
        </div>
      </div>
    </li>`;
  
      return productCard;
    }
  
    function createCart(products, cartJson) {
      let totalSavings = 0;
      
      cartJson.items.forEach(item => {
        totalSavings += item.line_price - item.price;
      })

      const fullCartBase = `<section class="cart-products cart-products--full"><ul class="products-container">${products}</ul>
      <div class="cart-footer">
        <div class="cart-total">
          <div class="cart-total__info">
            <p class="cart-total__subtitile">Subtotal</p>
            <p class="cart-total__data">$${cartJson.total_price / 100}</p>
          </div>
    
          <div class="cart-total__info">
            <p class="cart-total__subtitile">Total Savings</p>
            <p class="cart-total__data">-$${Math.round((window.totalSavings + Number.EPSILON) * 100) / 100}</p>
          </div>
        </div>
      
  
        <div class="checkout-button__container">
          <a href="/checkouts/cn/${
            cartJson.token
          }" class="cart-button"><span>CHECKOUT</span></a>
        </div>
        <p class="guarantee">30-Day Money Back Guarantee</p>
        <ul class="list list-payment" role="list"><li class="list-payment__item"><svg class="icon icon--full-color" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby="pi-american_express" viewBox="0 0 38 24" width="38" height="24"><title id="pi-american_express">American Express</title><path fill="#000" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3Z" opacity=".07"></path><path fill="#006FCF" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32Z"></path><path fill="#FFF" d="M22.012 19.936v-8.421L37 11.528v2.326l-1.732 1.852L37 17.573v2.375h-2.766l-1.47-1.622-1.46 1.628-9.292-.02Z"></path><path fill="#006FCF" d="M23.013 19.012v-6.57h5.572v1.513h-3.768v1.028h3.678v1.488h-3.678v1.01h3.768v1.531h-5.572Z"></path><path fill="#006FCF" d="m28.557 19.012 3.083-3.289-3.083-3.282h2.386l1.884 2.083 1.89-2.082H37v.051l-3.017 3.23L37 18.92v.093h-2.307l-1.917-2.103-1.898 2.104h-2.321Z"></path><path fill="#FFF" d="M22.71 4.04h3.614l1.269 2.881V4.04h4.46l.77 2.159.771-2.159H37v8.421H19l3.71-8.421Z"></path><path fill="#006FCF" d="m23.395 4.955-2.916 6.566h2l.55-1.315h2.98l.55 1.315h2.05l-2.904-6.566h-2.31Zm.25 3.777.875-2.09.873 2.09h-1.748Z"></path><path fill="#006FCF" d="M28.581 11.52V4.953l2.811.01L32.84 9l1.456-4.046H37v6.565l-1.74.016v-4.51l-1.644 4.494h-1.59L30.35 7.01v4.51h-1.768Z"></path></svg></li><li class="list-payment__item"><svg class="icon icon--full-color" viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg" role="img" width="38" height="24" aria-labelledby="pi-diners_club"><title id="pi-diners_club">Diners Club</title><path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"></path><path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"></path><path d="M12 12v3.7c0 .3-.2.3-.5.2-1.9-.8-3-3.3-2.3-5.4.4-1.1 1.2-2 2.3-2.4.4-.2.5-.1.5.2V12zm2 0V8.3c0-.3 0-.3.3-.2 2.1.8 3.2 3.3 2.4 5.4-.4 1.1-1.2 2-2.3 2.4-.4.2-.4.1-.4-.2V12zm7.2-7H13c3.8 0 6.8 3.1 6.8 7s-3 7-6.8 7h8.2c3.8 0 6.8-3.1 6.8-7s-3-7-6.8-7z" fill="#3086C8"></path></svg></li><li class="list-payment__item"><svg class="icon icon--full-color" viewBox="0 0 38 24" width="38" height="24" role="img" aria-labelledby="pi-discover" fill="none" xmlns="http://www.w3.org/2000/svg"><title id="pi-discover">Discover</title><path fill="#000" opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"></path><path d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32z" fill="#fff"></path><path d="M3.57 7.16H2v5.5h1.57c.83 0 1.43-.2 1.96-.63.63-.52 1-1.3 1-2.11-.01-1.63-1.22-2.76-2.96-2.76zm1.26 4.14c-.34.3-.77.44-1.47.44h-.29V8.1h.29c.69 0 1.11.12 1.47.44.37.33.59.84.59 1.37 0 .53-.22 1.06-.59 1.39zm2.19-4.14h1.07v5.5H7.02v-5.5zm3.69 2.11c-.64-.24-.83-.4-.83-.69 0-.35.34-.61.8-.61.32 0 .59.13.86.45l.56-.73c-.46-.4-1.01-.61-1.62-.61-.97 0-1.72.68-1.72 1.58 0 .76.35 1.15 1.35 1.51.42.15.63.25.74.31.21.14.32.34.32.57 0 .45-.35.78-.83.78-.51 0-.92-.26-1.17-.73l-.69.67c.49.73 1.09 1.05 1.9 1.05 1.11 0 1.9-.74 1.9-1.81.02-.89-.35-1.29-1.57-1.74zm1.92.65c0 1.62 1.27 2.87 2.9 2.87.46 0 .86-.09 1.34-.32v-1.26c-.43.43-.81.6-1.29.6-1.08 0-1.85-.78-1.85-1.9 0-1.06.79-1.89 1.8-1.89.51 0 .9.18 1.34.62V7.38c-.47-.24-.86-.34-1.32-.34-1.61 0-2.92 1.28-2.92 2.88zm12.76.94l-1.47-3.7h-1.17l2.33 5.64h.58l2.37-5.64h-1.16l-1.48 3.7zm3.13 1.8h3.04v-.93h-1.97v-1.48h1.9v-.93h-1.9V8.1h1.97v-.94h-3.04v5.5zm7.29-3.87c0-1.03-.71-1.62-1.95-1.62h-1.59v5.5h1.07v-2.21h.14l1.48 2.21h1.32l-1.73-2.32c.81-.17 1.26-.72 1.26-1.56zm-2.16.91h-.31V8.03h.33c.67 0 1.03.28 1.03.82 0 .55-.36.85-1.05.85z" fill="#231F20"></path><path d="M20.16 12.86a2.931 2.931 0 100-5.862 2.931 2.931 0 000 5.862z" fill="url(#pi-paint0_linear)"></path><path opacity=".65" d="M20.16 12.86a2.931 2.931 0 100-5.862 2.931 2.931 0 000 5.862z" fill="url(#pi-paint1_linear)"></path><path d="M36.57 7.506c0-.1-.07-.15-.18-.15h-.16v.48h.12v-.19l.14.19h.14l-.16-.2c.06-.01.1-.06.1-.13zm-.2.07h-.02v-.13h.02c.06 0 .09.02.09.06 0 .05-.03.07-.09.07z" fill="#231F20"></path><path d="M36.41 7.176c-.23 0-.42.19-.42.42 0 .23.19.42.42.42.23 0 .42-.19.42-.42 0-.23-.19-.42-.42-.42zm0 .77c-.18 0-.34-.15-.34-.35 0-.19.15-.35.34-.35.18 0 .33.16.33.35 0 .19-.15.35-.33.35z" fill="#231F20"></path><path d="M37 12.984S27.09 19.873 8.976 23h26.023a2 2 0 002-1.984l.024-3.02L37 12.985z" fill="#F48120"></path><defs><linearGradient id="pi-paint0_linear" x1="21.657" y1="12.275" x2="19.632" y2="9.104" gradientUnits="userSpaceOnUse"><stop stop-color="#F89F20"></stop><stop offset=".25" stop-color="#F79A20"></stop><stop offset=".533" stop-color="#F68D20"></stop><stop offset=".62" stop-color="#F58720"></stop><stop offset=".723" stop-color="#F48120"></stop><stop offset="1" stop-color="#F37521"></stop></linearGradient><linearGradient id="pi-paint1_linear" x1="21.338" y1="12.232" x2="18.378" y2="6.446" gradientUnits="userSpaceOnUse"><stop stop-color="#F58720"></stop><stop offset=".359" stop-color="#E16F27"></stop><stop offset=".703" stop-color="#D4602C"></stop><stop offset=".982" stop-color="#D05B2E"></stop></linearGradient></defs></svg></li><li class="list-payment__item"><svg class="icon icon--full-color" width="38" height="24" role="img" aria-labelledby="pi-jcb" viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg"><title id="pi-jcb">JCB</title><g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z" fill="#000" opacity=".07"></path><path d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32" fill="#FFF"></path></g><path d="M11.5 5H15v11.5a2.5 2.5 0 0 1-2.5 2.5H9V7.5A2.5 2.5 0 0 1 11.5 5z" fill="#006EBC"></path><path d="M18.5 5H22v11.5a2.5 2.5 0 0 1-2.5 2.5H16V7.5A2.5 2.5 0 0 1 18.5 5z" fill="#F00036"></path><path d="M25.5 5H29v11.5a2.5 2.5 0 0 1-2.5 2.5H23V7.5A2.5 2.5 0 0 1 25.5 5z" fill="#2AB419"></path><path d="M10.755 14.5c-1.06 0-2.122-.304-2.656-.987l.78-.676c.068 1.133 3.545 1.24 3.545-.19V9.5h1.802v3.147c0 .728-.574 1.322-1.573 1.632-.466.144-1.365.221-1.898.221zm8.116 0c-.674 0-1.388-.107-1.965-.366-.948-.425-1.312-1.206-1.3-2.199.012-1.014.436-1.782 1.468-2.165 1.319-.49 3.343-.261 3.926.27v.972c-.572-.521-1.958-.898-2.919-.46-.494.226-.737.917-.744 1.448-.006.56.245 1.252.744 1.497.953.467 2.39.04 2.919-.441v1.01c-.358.255-1.253.434-2.129.434zm8.679-2.587c.37-.235.582-.567.582-1.005 0-.438-.116-.687-.348-.939-.206-.207-.58-.469-1.238-.469H23v5h3.546c.696 0 1.097-.23 1.315-.415.283-.25.426-.53.426-.96 0-.431-.155-.908-.737-1.212zm-1.906-.281h-1.428v-1.444h1.495c.956 0 .944 1.444-.067 1.444zm.288 2.157h-1.716v-1.513h1.716c.986 0 1.083 1.513 0 1.513z" fill="#FFF" fill-rule="nonzero"></path></g></svg></li><li class="list-payment__item"><svg class="icon icon--full-color" viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg" role="img" width="38" height="24" aria-labelledby="pi-master"><title id="pi-master">Mastercard</title><path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"></path><path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"></path><circle fill="#EB001B" cx="15" cy="12" r="7"></circle><circle fill="#F79E1B" cx="23" cy="12" r="7"></circle><path fill="#FF5F00" d="M22 12c0-2.4-1.2-4.5-3-5.7-1.8 1.3-3 3.4-3 5.7s1.2 4.5 3 5.7c1.8-1.2 3-3.3 3-5.7z"></path></svg></li><li class="list-payment__item"><svg class="icon icon--full-color" viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg" width="38" height="24" role="img" aria-labelledby="pi-paypal"><title id="pi-paypal">PayPal</title><path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"></path><path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"></path><path fill="#003087" d="M23.9 8.3c.2-1 0-1.7-.6-2.3-.6-.7-1.7-1-3.1-1h-4.1c-.3 0-.5.2-.6.5L14 15.6c0 .2.1.4.3.4H17l.4-3.4 1.8-2.2 4.7-2.1z"></path><path fill="#3086C8" d="M23.9 8.3l-.2.2c-.5 2.8-2.2 3.8-4.6 3.8H18c-.3 0-.5.2-.6.5l-.6 3.9-.2 1c0 .2.1.4.3.4H19c.3 0 .5-.2.5-.4v-.1l.4-2.4v-.1c0-.2.3-.4.5-.4h.3c2.1 0 3.7-.8 4.1-3.2.2-1 .1-1.8-.4-2.4-.1-.5-.3-.7-.5-.8z"></path><path fill="#012169" d="M23.3 8.1c-.1-.1-.2-.1-.3-.1-.1 0-.2 0-.3-.1-.3-.1-.7-.1-1.1-.1h-3c-.1 0-.2 0-.2.1-.2.1-.3.2-.3.4l-.7 4.4v.1c0-.3.3-.5.6-.5h1.3c2.5 0 4.1-1 4.6-3.8v-.2c-.1-.1-.3-.2-.5-.2h-.1z"></path></svg></li><li class="list-payment__item"><svg class="icon icon--full-color" viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg" role="img" width="38" height="24" aria-labelledby="pi-visa"><title id="pi-visa">Visa</title><path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"></path><path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"></path><path d="M28.3 10.1H28c-.4 1-.7 1.5-1 3h1.9c-.3-1.5-.3-2.2-.6-3zm2.9 5.9h-1.7c-.1 0-.1 0-.2-.1l-.2-.9-.1-.2h-2.4c-.1 0-.2 0-.2.2l-.3.9c0 .1-.1.1-.1.1h-2.1l.2-.5L27 8.7c0-.5.3-.7.8-.7h1.5c.1 0 .2 0 .2.2l1.4 6.5c.1.4.2.7.2 1.1.1.1.1.1.1.2zm-13.4-.3l.4-1.8c.1 0 .2.1.2.1.7.3 1.4.5 2.1.4.2 0 .5-.1.7-.2.5-.2.5-.7.1-1.1-.2-.2-.5-.3-.8-.5-.4-.2-.8-.4-1.1-.7-1.2-1-.8-2.4-.1-3.1.6-.4.9-.8 1.7-.8 1.2 0 2.5 0 3.1.2h.1c-.1.6-.2 1.1-.4 1.7-.5-.2-1-.4-1.5-.4-.3 0-.6 0-.9.1-.2 0-.3.1-.4.2-.2.2-.2.5 0 .7l.5.4c.4.2.8.4 1.1.6.5.3 1 .8 1.1 1.4.2.9-.1 1.7-.9 2.3-.5.4-.7.6-1.4.6-1.4 0-2.5.1-3.4-.2-.1.2-.1.2-.2.1zm-3.5.3c.1-.7.1-.7.2-1 .5-2.2 1-4.5 1.4-6.7.1-.2.1-.3.3-.3H18c-.2 1.2-.4 2.1-.7 3.2-.3 1.5-.6 3-1 4.5 0 .2-.1.2-.3.2M5 8.2c0-.1.2-.2.3-.2h3.4c.5 0 .9.3 1 .8l.9 4.4c0 .1 0 .1.1.2 0-.1.1-.1.1-.1l2.1-5.1c-.1-.1 0-.2.1-.2h2.1c0 .1 0 .1-.1.2l-3.1 7.3c-.1.2-.1.3-.2.4-.1.1-.3 0-.5 0H9.7c-.1 0-.2 0-.2-.2L7.9 9.5c-.2-.2-.5-.5-.9-.6-.6-.3-1.7-.5-1.9-.5L5 8.2z" fill="#142688"></path></svg></li>
        <li class="list-payment__item"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="255.28pt" height="188.53pt" viewBox="0 0 255.28 188.53" version="1.1"><defs><clipPath id="clip1"><path d="M 50 0 L 255.28125 0 L 255.28125 188.53125 L 50 188.53125 Z M 50 0 "></path></clipPath></defs><g id="surface1"><path style=" stroke:none;fill-rule:nonzero;fill:rgb(72.898865%,59.199524%,39.599609%);fill-opacity:1;" d="M 186.574219 93.289063 C 186.574219 144.808594 144.808594 186.574219 93.285156 186.574219 C 41.765625 186.574219 0 144.808594 0 93.289063 C 0 41.765625 41.765625 0 93.285156 0 C 144.808594 0 186.574219 41.765625 186.574219 93.289063 "></path><path style=" stroke:none;fill-rule:nonzero;fill:rgb(92.89856%,10.998535%,14.099121%);fill-opacity:1;" d="M 179.25 93.289063 C 179.25 140.765625 140.761719 179.25 93.285156 179.25 C 45.8125 179.25 7.324219 140.765625 7.324219 93.289063 C 7.324219 45.8125 45.8125 7.328125 93.285156 7.328125 C 140.761719 7.328125 179.25 45.8125 179.25 93.289063 "></path><path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 250.8125 94.679688 C 250.8125 144.40625 206.960938 184.714844 152.871094 184.714844 C 98.78125 184.714844 54.929688 144.40625 54.929688 94.679688 C 54.929688 44.953125 98.78125 4.644531 152.871094 4.644531 C 206.960938 4.644531 250.8125 44.953125 250.8125 94.679688 "></path><g clip-path="url(#clip1)" clip-rule="nonzero"><path style=" stroke:none;fill-rule:nonzero;fill:rgb(72.898865%,59.199524%,39.599609%);fill-opacity:1;" d="M 153.039063 181.691406 C 100.667969 181.691406 58.210938 142.550781 58.210938 94.265625 C 58.210938 45.980469 100.667969 6.839844 153.039063 6.839844 C 205.40625 6.839844 247.863281 45.980469 247.863281 94.265625 C 247.863281 142.550781 205.40625 181.691406 153.039063 181.691406 Z M 153.039063 0 C 96.570313 0 50.796875 42.203125 50.796875 94.265625 C 50.796875 146.324219 96.570313 188.53125 153.039063 188.53125 C 209.503906 188.53125 255.277344 146.324219 255.277344 94.265625 C 255.277344 42.203125 209.503906 0 153.039063 0 "></path></g><path style=" stroke:none;fill-rule:nonzero;fill:rgb(72.898865%,59.199524%,39.599609%);fill-opacity:1;" d="M 134.535156 80.304688 L 134.535156 73.171875 L 109.289063 73.171875 L 109.289063 80.304688 L 114.285156 80.304688 L 112.929688 91.742188 L 94.992188 91.742188 L 96.347656 80.304688 L 102.882813 80.304688 L 102.882813 73.171875 L 77.632813 73.171875 L 77.632813 80.304688 L 83.132813 80.304688 L 79.3125 112.582031 L 71.96875 112.582031 L 71.96875 119.71875 L 97.21875 119.71875 L 97.21875 112.582031 L 92.527344 112.582031 L 94.210938 98.351563 L 112.148438 98.351563 L 110.460938 112.582031 L 103.625 112.582031 L 103.625 119.71875 L 128.875 119.71875 L 128.875 112.582031 L 123.679688 112.582031 L 127.5 80.304688 L 134.535156 80.304688 "></path><path style=" stroke:none;fill-rule:nonzero;fill:rgb(72.898865%,59.199524%,39.599609%);fill-opacity:1;" d="M 181.363281 87.964844 L 174.992188 87.964844 C 174.992188 87.964844 170.511719 77.820313 160.597656 78.054688 C 152.339844 78.289063 152.574219 83.011719 152.574219 83.011719 C 152.574219 83.011719 152.710938 87.101563 158.570313 87.753906 C 158.570313 87.753906 182.667969 90.847656 182.667969 101.265625 C 182.667969 101.265625 184.785156 113.640625 168.339844 118.035156 C 168.339844 118.035156 155.640625 121.128906 147.011719 114.777344 C 147.011719 114.777344 145.710938 114.453125 145.710938 115.265625 C 145.710938 116.082031 143.921875 117.871094 143.921875 117.871094 L 136.917969 117.871094 L 136.917969 101.265625 C 136.917969 101.265625 140.988281 99.148438 144.570313 101.101563 C 144.570313 101.101563 148.152344 110.546875 154.664063 111.359375 C 158.605469 111.851563 168.011719 113.199219 170.253906 108.726563 C 172.988281 103.261719 161.777344 101.414063 158.410156 100.453125 C 152.710938 98.824219 140.175781 96.542969 140.339844 87.101563 C 140.339844 87.101563 139.199219 74.078125 156.292969 71.636719 C 156.292969 71.636719 164.921875 70.171875 171.109375 73.261719 C 171.109375 73.261719 174.363281 74.078125 174.851563 72.9375 C 174.851563 72.9375 175.503906 70.335938 181.203125 72.125 L 181.363281 87.964844 "></path><path style=" stroke:none;fill-rule:nonzero;fill:rgb(72.898865%,59.199524%,39.599609%);fill-opacity:1;" d="M 205.136719 96.871094 L 212.296875 82.382813 L 216.367188 96.871094 Z M 233.949219 110.707031 L 221.578125 71.636719 L 209.855469 71.636719 L 186.390625 111.199219 L 182.015625 111.199219 L 182.015625 118.035156 L 202.691406 118.035156 L 202.691406 111.199219 L 197.550781 111.199219 L 202.53125 102.566406 L 217.996094 102.566406 L 220.261719 110.707031 L 213.601563 110.707031 L 213.601563 118.035156 L 237.695313 118.035156 L 237.695313 110.707031 L 233.949219 110.707031 "></path><path style=" stroke:none;fill-rule:nonzero;fill:rgb(17.999268%,18.798828%,57.299805%);fill-opacity:1;" d="M 182.992188 127.152344 L 124.058594 127.152344 C 124.058594 127.152344 133.824219 138.546875 152.386719 139.035156 C 170.945313 139.527344 182.992188 127.152344 182.992188 127.152344 "></path><path style="fill:none;stroke-width:10;stroke-linecap:butt;stroke-linejoin:miter;stroke:rgb(13.699341%,12.199402%,12.5%);stroke-opacity:1;stroke-miterlimit:4;" d="M 1829.921875 613.776562 L 1240.585938 613.776562 C 1240.585938 613.776562 1338.242188 499.83125 1523.867188 494.948437 C 1709.453125 490.026562 1829.921875 613.776562 1829.921875 613.776562 Z M 1829.921875 613.776562 " transform="matrix(0.1,0,0,-0.1,0,188.53)"></path><path style=" stroke:none;fill-rule:nonzero;fill:rgb(17.999268%,18.798828%,57.299805%);fill-opacity:1;" d="M 195.113281 127.125 C 188.246094 137.382813 172.027344 144.589844 153.117188 144.589844 C 134.207031 144.589844 117.992188 137.382813 111.121094 127.125 L 105.898438 127.125 C 111.941406 139.847656 130.792969 149.128906 153.117188 149.128906 C 175.441406 149.128906 194.296875 139.847656 200.335938 127.125 L 195.113281 127.125 "></path><path style="fill:none;stroke-width:10;stroke-linecap:butt;stroke-linejoin:miter;stroke:rgb(13.699341%,12.199402%,12.5%);stroke-opacity:1;stroke-miterlimit:4;" d="M 1951.132813 614.05 C 1882.460938 511.471875 1720.273438 439.401562 1531.171875 439.401562 C 1342.070313 439.401562 1179.921875 511.471875 1111.210938 614.05 L 1058.984375 614.05 C 1119.414063 486.823437 1307.929688 394.010937 1531.171875 394.010937 C 1754.414063 394.010937 1942.96875 486.823437 2003.359375 614.05 Z M 1951.132813 614.05 " transform="matrix(0.1,0,0,-0.1,0,188.53)"></path><path style=" stroke:none;fill-rule:nonzero;fill:rgb(17.999268%,18.798828%,57.299805%);fill-opacity:1;" d="M 209.0625 127.125 C 200.015625 143.179688 177.652344 156.890625 152.742188 156.890625 C 127.835938 156.890625 105.601563 143.179688 96.550781 127.125 L 90.546875 127.125 C 99.171875 145.09375 123.335938 161.570313 152.742188 161.570313 C 182.148438 161.570313 206.441406 145.28125 214.863281 127.125 L 209.0625 127.125 "></path><path style="fill:none;stroke-width:10;stroke-linecap:butt;stroke-linejoin:miter;stroke:rgb(13.699341%,12.199402%,12.5%);stroke-opacity:1;stroke-miterlimit:4;" d="M 2090.625 614.05 C 2000.15625 453.503125 1776.523438 316.39375 1527.421875 316.39375 C 1278.359375 316.39375 1056.015625 453.503125 965.507813 614.05 L 905.46875 614.05 C 991.71875 434.3625 1233.359375 269.596875 1527.421875 269.596875 C 1821.484375 269.596875 2064.414063 432.4875 2148.632813 614.05 Z M 2090.625 614.05 " transform="matrix(0.1,0,0,-0.1,0,188.53)"></path><path style=" stroke:none;fill-rule:nonzero;fill:rgb(17.999268%,18.798828%,57.299805%);fill-opacity:1;" d="M 225.398438 127.125 C 213.804688 149.550781 185.144531 169.433594 153.222656 169.433594 C 121.296875 169.433594 92.800781 149.550781 81.207031 127.125 L 73.515625 127.125 C 84.566406 152.226563 115.535156 175.234375 153.222656 175.234375 C 190.910156 175.234375 221.289063 152.488281 232.089844 127.125 L 225.398438 127.125 "></path><path style="fill:none;stroke-width:10;stroke-linecap:butt;stroke-linejoin:miter;stroke:rgb(13.699341%,12.199402%,12.5%);stroke-opacity:1;stroke-miterlimit:4;" d="M 2253.984375 614.05 C 2138.046875 389.792187 1851.445313 190.964062 1532.226563 190.964062 C 1212.96875 190.964062 928.007813 389.792187 812.070313 614.05 L 735.15625 614.05 C 845.664063 363.034375 1155.351563 132.95625 1532.226563 132.95625 C 1909.101563 132.95625 2212.890625 360.417187 2320.898438 614.05 Z M 2253.984375 614.05 " transform="matrix(0.1,0,0,-0.1,0,188.53)"></path><path style=" stroke:none;fill-rule:nonzero;fill:rgb(92.89856%,10.998535%,14.099121%);fill-opacity:1;" d="M 216.855469 67.730469 L 86.613281 67.730469 L 86.613281 62.519531 L 216.855469 62.519531 L 216.855469 67.730469 "></path><path style="fill:none;stroke-width:10;stroke-linecap:butt;stroke-linejoin:miter;stroke:rgb(13.699341%,12.199402%,12.5%);stroke-opacity:1;stroke-miterlimit:4;" d="M 1579.21875 1644.557813 L 1452.226563 1644.557813 L 1452.226563 1677.760938 L 1579.21875 1677.760938 Z M 1579.21875 1644.557813 " transform="matrix(0.1,0,0,-0.1,0,188.53)"></path><path style=" stroke:none;fill-rule:nonzero;fill:rgb(72.898865%,59.199524%,39.599609%);fill-opacity:1;" d="M 205.867188 51.691406 L 202.691406 51.691406 L 202.691406 48.515625 L 205.867188 48.515625 Z M 201.714844 41.921875 L 204.890625 41.921875 L 204.890625 45.097656 L 201.714844 45.097656 Z M 200.25 34.597656 L 203.425781 34.597656 L 203.425781 37.773438 L 200.25 37.773438 Z M 199.761719 51.449219 L 196.585938 51.449219 L 196.585938 48.273438 L 199.761719 48.273438 Z M 195.609375 41.679688 L 198.785156 41.679688 L 198.785156 44.855469 L 195.609375 44.855469 Z M 194.144531 34.351563 L 197.320313 34.351563 L 197.320313 37.527344 L 194.144531 37.527344 Z M 192.679688 45.585938 L 189.503906 45.585938 L 189.503906 42.410156 L 192.679688 42.410156 Z M 192.679688 52.179688 L 189.503906 52.179688 L 189.503906 49.003906 L 192.679688 49.003906 Z M 189.015625 35.085938 L 192.191406 35.085938 L 192.191406 38.261719 L 189.015625 38.261719 Z M 175.339844 47.296875 L 129.429688 47.296875 L 129.429688 45.34375 L 175.339844 45.34375 Z M 175.339844 53.890625 L 129.429688 53.890625 L 129.429688 51.9375 L 175.339844 51.9375 Z M 137.734375 38.097656 L 141.964844 38.097656 L 141.964844 43.957031 L 137.734375 43.957031 Z M 138.710938 32.5625 L 141.640625 32.5625 L 141.640625 36.144531 L 138.710938 36.144531 Z M 138.710938 26.050781 L 141.640625 26.050781 L 141.640625 29.632813 L 138.710938 29.632813 Z M 158.980469 36.550781 L 158.980469 42.898438 L 143.839844 42.898438 L 143.839844 36.550781 Z M 143.59375 31.585938 L 159.875 31.585938 L 159.875 33.214844 L 143.59375 33.214844 Z M 161.503906 32.5625 L 164.433594 32.5625 L 164.433594 36.144531 L 161.503906 36.144531 Z M 167.039063 38.097656 L 167.039063 43.957031 L 162.804688 43.957031 L 162.804688 38.097656 Z M 161.503906 26.050781 L 164.433594 26.050781 L 164.433594 29.632813 L 161.503906 29.632813 Z M 114.914063 38.261719 L 111.738281 38.261719 L 111.738281 35.085938 L 114.914063 35.085938 Z M 114.425781 45.585938 L 111.25 45.585938 L 111.25 42.410156 L 114.425781 42.410156 Z M 114.425781 52.179688 L 111.25 52.179688 L 111.25 49.003906 L 114.425781 49.003906 Z M 109.785156 37.527344 L 106.609375 37.527344 L 106.609375 34.351563 L 109.785156 34.351563 Z M 108.320313 44.855469 L 105.144531 44.855469 L 105.144531 41.679688 L 108.320313 41.679688 Z M 107.34375 51.449219 L 104.167969 51.449219 L 104.167969 48.273438 L 107.34375 48.273438 Z M 103.679688 37.773438 L 100.507813 37.773438 L 100.507813 34.597656 L 103.679688 34.597656 Z M 102.214844 45.097656 L 99.039063 45.097656 L 99.039063 41.921875 L 102.214844 41.921875 Z M 101.238281 51.691406 L 98.0625 51.691406 L 98.0625 48.515625 L 101.238281 48.515625 Z M 206.421875 35.5625 C 205.386719 27.074219 195.289063 26.078125 188.210938 28.710938 C 186.867188 29.210938 182.820313 33.214844 181.964844 33.214844 C 181.90625 33.214844 167.441406 33.214844 167.441406 33.214844 L 167.441406 22.46875 L 160.742188 22.46875 L 160.742188 18.234375 L 143.269531 18.234375 L 143.269531 23.769531 L 136.757813 23.769531 L 136.757813 34.191406 L 122.105469 34.191406 L 120.476563 32.5625 C 120.476563 32.5625 112.011719 26.375 102.566406 29.632813 C 95.730469 30.933594 96.382813 57.960938 96.382813 57.960938 C 96.382813 57.960938 101.589844 55.03125 106.476563 55.03125 C 111.359375 55.03125 116.242188 57.960938 116.242188 57.960938 L 116.3125 35.167969 L 119.171875 35.167969 L 119.171875 56.65625 L 121.128906 56.65625 L 121.128906 45.910156 L 126.660156 45.910156 C 124.710938 52.425781 129.59375 56.65625 129.59375 56.65625 L 174.527344 56.65625 C 180.0625 56.332031 177.78125 45.261719 177.78125 45.261719 L 181.691406 45.261719 L 183.644531 56.332031 L 184.945313 56.984375 L 184.945313 33.539063 L 187.550781 33.539063 L 187.550781 57.308594 C 187.550781 57.308594 194.390625 53.726563 197.972656 53.726563 C 201.554688 53.726563 209.042969 56.007813 209.042969 56.007813 C 208.167969 49.191406 207.253906 42.382813 206.421875 35.5625 "></path></g></svg></li>
        </ul>
        
          <button class="cart-button"><span>CONTINUE SHOPPING</span></button>
        </div>
      </section>`;
  
      return fullCartBase;
    }
  
    const emptyCart = `<section class="cart-products  cart-products--empty"><div  class="cart-products__empty-svg"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <style type="text/css"> .st0{fill:#171E48;} </style> <path class="st0" d="M256,0C114.6,0,0,114.6,0,256s114.6,256,256,256s256-114.6,256-256S397.4,0,256,0z M256,480 C132.3,480,32,379.7,32,256S132.3,32,256,32s224,100.3,224,224S379.7,480,256,480z"></path> <circle class="st0" cx="176" cy="176" r="32"></circle> <circle class="st0" cx="336" cy="176" r="32"></circle> <path class="st0" d="M256,240c-79.5,0-144,64.5-144,144h32c0-61.9,50.1-112,112-112s112,50.1,112,112h32 C400,304.5,335.5,240,256,240z"></path> </svg></div><h2 class="empty__title">Your cart is empty</h2><button class="cart-button"><span>CONTINUE SHOPPING</span></button></section>`
  
  function updateCartCount(quantity) {
    const cartCount = document.querySelector(".cart-count");
  
    cartCount.innerText = quantity;
  }*/
  
  // Update cart on Load
  async function getCart() {
      const cartJson = await (
        await fetch(`/cart`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
      ).json();
      
      window.totalSavings = 0;
      window.allProducts = await (
        await fetch("/products.json", {
          method: "GET",
          headers: {
            'Authorization': 'Basic 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',
            'Content-Type': 'application/json'
          },
        })
      ).json();
      
      window.totalSavings = 0;
      const newCartJson = await getProdAllData(cartJson);
  
      updateCart(newCartJson);
      updateCartCount(cartJson.item_count);
    }
    
    function getProdAllData(cartJson) {
      const newCartJson = cartJson.items.map(cartItem => {
        window.allProducts.products.forEach(prod => {
          prod.variants.forEach(variant => {
            if (cartItem.id === variant.id) {
              cartItem = { ...cartItem, compare_at_price: variant.compare_at_price }
              window.totalSavings += (variant.compare_at_price * cartItem.quantity) - (cartItem.line_price / 100);
            }
          })
        })
        
        return cartItem;
      })
      
      return {
        ...cartJson,
        items: newCartJson
      };
    }
  
  getCart();
  
  // Update Cart Item Quantity
  const cartDrawerE = document.getElementById("cart-drawer");

  cartDrawerE.addEventListener("click", (e) => {
    if (e.target.classList.contains("quant-selector__button")) {
      const element = e.target.closest(".quant-selector");
      updateCartItemQuantity(e, element);
    }
  });
  
  function updateCartItemQuantity(e, element) {
    if (e.target.dataset.type === "minus") {
      const input = element.querySelector("input");
      const newQuantity = +input.value - 1;
      input.value = newQuantity;

      updateCartBackend(e, input.dataset.index, newQuantity);
    } else if (e.target.dataset.type === "plus") {
      const input = element.querySelector("input");
      const newQuantity = +input.value + 1;
      input.value = newQuantity;

      updateCartBackend(e, input.dataset.index, newQuantity);
    }
  }
  
  function updateCartBackend(e, line, quantity) {
    const parent = e.target.closest(".explore-product");
    parent.classList.add("ldng");
    const body = JSON.stringify({
      line,
      quantity,
      sections: ["cart-drawer"],
    });

    fetch(`/cart/change`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: body,
    })
      .then((response) => response.json())
      .then(async (parsedState) => {
        handleErrorMessage(parsedState);
        const cartJson = await (
          await fetch(`/cart`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          })
        ).json();

        window.totalSavings = 0;
        const newCartJson = await getProdAllData(cartJson);

        updateCart(newCartJson);
        updateCartCount(cartJson.item_count);
      });
  }
  
  function handleErrorMessage(errorMessage) {
    console.error(errorMessage);
  }
  
  const singleProductForms = document.querySelectorAll(
    "form.shopify-product-form.explore-product"
  );
  if (singleProductForms && singleProductForms.length > 0) {
    singleProductForms.forEach((form) => {
      form.addEventListener("submit", (e) => {
        addSingleToCart(e, form);
      });
    });
  }
}

if (!window.reviewsLogic) {
  window.reviewsLogic = true;
  
  const buttons = document.querySelectorAll(".reviews__select button");
  buttons.forEach(btn => {
    btn.addEventListener("click", (e) => {
      e.stopPropagation
      document.querySelector(".reviews__select button.active").classList.toggle("active");
      btn.classList.toggle("active");
    })
  })
}
if (!window.beforeAfter) {
  window.beforeAfter = true;

  const beforeAfterInner = document.querySelector(".before-after__inner");
  const beforeAfterButtons = document.querySelectorAll(
    ".before-after__controll"
  );
  let beforeAfterCurrent = 0;

  beforeAfterButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      if (btn.classList.contains("prev")) {
        beforeAfterCurrent -= 1;
        moveBeforeAfter();
      } else if (btn.classList.contains("next")) {
        beforeAfterCurrent += 1;
        moveBeforeAfter();
      }
    });
  });

  function moveBeforeAfter() {
    beforeAfterInner.style.transform = `translateX(-${
      beforeAfterCurrent * 100
    }%)`;

    if (beforeAfterCurrent === 0) {
      document
        .querySelector(".before-after__controll.prev")
        .classList.add("inactive");
    } else if (beforeAfterCurrent === 2) {
      document
        .querySelector(".before-after__controll.next")
        .classList.add("inactive");
    } else {
      document
        .querySelector(".before-after__controll.inactive")
        .classList.remove("inactive");
    }
  }
}